var oleoSubcategorias = {
  "tag:cat-cabine-chaparia": [
    {t:"Amortecedores", v:"tag:subcat-amortecedores"},
    {t:"Ar Condicionado", v:"tag:subcat-ar-condicionado"},
    {t:"Bancos e Capas", v:"tag:subcat-bancos-e-capas"},
    {t:"Cabos", v:"tag:subcat-cabos"},
    {t:"Chaparia", v:"tag:subcat-chaparia"},
    {t:"Espelhos e Braços", v:"tag:subcat-espelhos-e-bracos"},
    {t:"Interior de Cabine", v:"tag:subcat-interior-de-cabine"},
    {t:"Motores, Escovas e Kits Limpa Vidros", v:"tag:subcat-motores-escovas-e-kits-limpa-vidros"},
    {t:"Vidros de Cabine e Acessórios", v:"tag:subcat-vidros-de-cabine-e-acessorios"}
  ],
  "tag:cat-electricos": [
    {t:"Iluminação de Reboques", v:"tag:subcat-iluminacao-de-reboques"},
    {t:"Interruptores e Sensores", v:"tag:subcat-interruptores-e-sensores"},
    {t:"Veículos - Componentes Eléctricos", v:"tag:subcat-veiculos-componentes-electricos"},
    {t:"Veículos - Iluminação", v:"tag:subcat-veiculos-iluminacao"}
  ],
  "tag:cat-eixos-transmissao": [
    {t:"Eixo Frontal e Direção", v:"tag:subcat-eixo-frontal-e-direcao"},
    {t:"Componentes 2WD", v:"tag:subcat-componentes-2WD"},
    {t:"Componentes 4WD", v:"tag:subcat-componentes-4WD"},
    {t:"Eixo Traseiro", v:"tag:subcat-eixo-traseiro"},
    {t:"Embraiagens e Volantes de Motor", v:"tag:subcat-embraiagens-e-volantes-de-motor"},
    {t:"Rodas e Guarda-lamas", v:"tag:subcat-rodas-e-guarda-lamas"},
    {t:"Trator - Hidráulico", v:"tag:subcat-tractor-hidraulico"},
    {t:"Transmissão", v:"tag:subcat-transmissao"},
    {t:"Travão", v:"tag:subcat-travao"}
  ],
  "tag:cat-engate-3ponto": [
    {t:"3ºs Pontos", v:"tag:subcat-3os-pontos"},
    {t:"3ºs Pontos Hidráulicos", v:"tag:subcat-3os-pontos-hidraulicos"},
    {t:"Barras Estabilizadoras", v:"tag:subcat-barras-estabilizadoras"},
    {t:"Barras Inferiores e Componentes", v:"tag:subcat-barras-inferiores-e-componentes"},
    {t:"Braços de Elevação e Veios", v:"tag:subcat-bracos-de-elevacao-e-veios"},
    {t:"Braços Hidráulicos", v:"tag:subcat-bracos-hidraulicos"},
    {t:"Braços Hidráulicos e Componentes", v:"tag:subcat-bracos-hidraulicos-e-componentes"},
    {t:"Cavilhas e Munhões", v:"tag:subcat-cavilhas-e-munhoes"},
    {t:"Cavilhas Mola", v:"tag:subcat-cavilhas-mola"},
    {t:"Componentes para 3º Pontos", v:"tag:subcat-componentes-para-3o-pontos"},
    {t:"Estabilizadores", v:"tag:subcat-estabilizadores"},
    {t:"Rótulas e Casquilhos", v:"tag:subcat-rotulas-e-casquilhos"}
  ],
  "tag:cat-hidraulico": [
    {t:"Conexões Multi Portas (Faster)", v:"tag:subcat-conexoes-multi-portas-faster"},
    {t:"Racords para Tubo Hidráulico", v:"tag:subcat-racords-para-tubo-hidraulico"},
    {t:"Tubo Hidráulico e Acessórios", v:"tag:subcat-tubo-hidraulico-e-acessorios"},
    {t:"Tubos Metal", v:"tag:subcat-tubos-metal"},
    {t:"Válvulas e Acessórios", v:"tag:subcat-valvulas-e-acessorios"}
  ],
  "tag:cat-motor-filtros": [
    {t:"Componentes de Alimentação Combustível", v:"tag:subcat-componentes-de-alimentacao-combustivel"},
    {t:"Componentes de Arrefecimento", v:"tag:subcat-componentes-de-arrefecimento"},
    {t:"Componentes de Escape", v:"tag:subcat-componentes-de-escape"},
    {t:"Componentes de Motor", v:"tag:subcat-componentes-de-motor"},
    {t:"Componentes Específicos", v:"tag:subcat-componentes-especificos"},
    {t:"Correias e Componentes", v:"tag:subcat-correias-e-componentes"},
    {t:"Filtros", v:"tag:subcat-filtros"},
    {t:"Motores de Arranque", v:"tag:subcat-motores-de-arranque"},
    {t:"Pré-Filtros", v:"tag:subcat-pre-trator"},
    {t:"Retentores", v:"tag:subcat-retentores"}
  ],
  "tag:cat-desgaste": [
    {t:"Colheita e Corte", v:"tag:subcat-colheita-e-corte"},
    {t:"Cultivo", v:"tag:subcat-cultivo"},
    {t:"Manuseio e Tratamento Químico", v:"tag:subcat-manuseio-e-tratamento-quimico"}
  ],
  "tag:cat-reboque-ferragens": [
    {t:"Abraçadeiras", v:"tag:subcat-abracadeiras"},
    {t:"Cabos, Cordas, Correntes e Componentes", v:"tag:subcat-cabos-cordas-correntes-e-componentes"},
    {t:"Cavilhas de Mola", v:"tag:subcat-cavilhas-de-mola"},
    {t:"Cavilhas tipo R", v:"tag:subcat-cavilhas-tipo-r"},
    {t:"Escateis", v:"tag:subcat-escateis"},
    {t:"Ferragens", v:"tag:subcat-ferragens"},
    {t:"Parafusos", v:"tag:subcat-parafusos"},
    {t:"Pregos", v:"tag:subcat-pregos"},
    {t:"Reboque", v:"tag:subcat-reboque"},
    {t:"Terminais e Forquilhas", v:"tag:subcat-terminais-e-forquilhas"}
  ],
  "tag:cat-tintas": [
    {t:"Equipamento Spray", v:"tag:subcat-equipamento-spray"},
    {t:"Tinta Agricolour", v:"tag:subcat-tinta-agricolour"}
  ],
  "tag:cat-transmissao-potencia": [
    {t:"Correias e Componentes", v:"tag:subcat-correias-e-componentes"},
    {t:"Correntes e Componentes", v:"tag:subcat-correntes-e-componentes"},
    {t:"Retentores de Óleo", v:"tag:subcat-retentores-de-oleo"},
    {t:"Rolamentos", v:"tag:subcat-rolamentos"}
  ],
  "tag:cat-transmissao-componentes": [
    {t:"Cruzetas", v:"tag:subcat-cruzetas"},
    {t:"Limitadores Torque PTO", v:"tag:subcat-limitadores-torque-pto"},
    {t:"Adaptadores PTO", v:"tag:subcat-adaptadores-pto"}
  ],
  "tag:cat-oficina-e-merchandising": [
    {t:"Consumíveis de Oficina", v:"tag:subcat-consumiveis-de-oficina"},
    {t:"Equipamento de Oficina", v:"tag:subcat-equipamento-de-oficina"},
    {t:"Ferramentas", v:"tag:subcat-ferramentas"},
    {t:"Produtos Químicos", v:"tag:subcat-produtos-quimicos"}
  ]
};



